import axios from 'axios'

export default {
  getMarks(simulatorId, filters, sorting, pageNumber, perPage) {
    let newSorting = {}

    if (sorting.length > 0) {
      newSorting = sorting
    } else {
      newSorting = [{ date: 'DESC' }]
    }

    const newQuery = {}

    newQuery.surname = (filters && filters.surname) ? filters.surname : ''
    newQuery.classes = (filters && filters.classes) ? filters.classes : [10, 11]
    if (filters && filters.date) {
      newQuery.date = filters.date
    }

    return axios.get(`/api/education/simulators/${simulatorId}/trainings/results`, {
      params: {
        ...newQuery, sorting: newSorting, pageNumber, perPage
      }
    })
  },

  changeMark(simulatorId, trainingSessionId, newMark) {
    return axios.put(`/api/education/simulators/${simulatorId}/trainings/results/${trainingSessionId}`, { mark: newMark })
  },

  getPersonMarks(simId) {
    return axios.get(`/api/education/simulators/${simId}/trainings`)
  }
}
